<template>
  <div class="sidebar">

<!-- 左上角返回工作台按钮 -->
    <div class="back-workbench-btn" @click="goToWorkbench">
      <span class="icon">←</span>
      <span class="text">返回工作台</span>
    </div>

    <el-menu
      class="el-menu-vertical-demo"
      v-bind:default-active="active"
      v-bind:unique-opened="uniqueOpened"
      v-on:select="select"
      @open="handleOpen"
      @close="handleClose"
      background-color="#272727"
      text-color="#fff"
      active-text-color="#ffd04b" >

      <div :key="menu.url" v-for="menu in menuData">
        <el-submenu v-bind:index="menu.url" v-if="menu.hasSubMenu">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>{{ menu.menuName }}</span>
          </template>
          <el-menu-item-group :key="subMenu.url" v-for="subMenu in menu.subMenuList">
            <el-menu-item v-bind:index="subMenu.url">{{ subMenu.menuName }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item v-bind:index="menu.url"  v-else>
          <i v-bind:class="menu.icon"></i>
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </div>
    </el-menu>

  </div>
</template>
<script>
export default {
  name: "SideBar",
  data() {
    return {
      active: "homeDoor",
      uniqueOpened: true,
      isCollapse: true,
      menuViewData: 2,  // 1单店报表，2全国报表
      menuData : [
        {
          menuId: 11,
          menuName: "全国报表",
          icon: "",
          url:"homeTotal",
          hasSubMenu: false,
          subMenuList:[]
        }
      ]
    }
  },
  mounted() {
    this.initMenu()
  },
  methods: {
    getFirstMenuKey (menu) {
      if (menu.hasSubMenu) {
        return menu.subMenuList[0].url + '-' + menu.subMenuList[0].menuCode
      } else {
        return menu.url + '-' + menu.menuCode
      }
    },
    initMenu(){
  const currentUrl = window.location.href
  this.menuViewData = localStorage.getItem("menuViewData") || 2

  // 兜底：取不到就给空数组，防止JSON.parse(null)报错
  let storageStr = localStorage.getItem("oprMenuData")
  let menuData = []
  if(storageStr){
    try {
      menuData = JSON.parse(storageStr)
    }catch(e){
      menuData = []
    }
  }

  let subItemTemp = []
  if (this.menuViewData == 1 && Array.isArray(menuData)){
    menuData.forEach(item =>{
      if (item.menuId == "home" && item.subMenuList){
        item.subMenuList.forEach(subItem =>{
          if (subItem.menuId == "homeDoor"){
            subItemTemp.push(subItem)
          }
        })
        item.subMenuList = subItemTemp
      }
    })
  }

  // 只有数组不为空才赋值
  if(Array.isArray(menuData) && menuData.length>0){
    this.menuData = menuData
  }

  if (currentUrl.indexOf('activityManage') !== -1) {
    this.active = 'activityManage'
    this.$store.commit("setMenuTitle", 'activityManage');
    return;
  }

  // 加判断，防止 menuData[0] 读取报错
  if(menuData && menuData.length>0){
    const indexMenu = this.getFirstMenuKey(menuData[0])
    let [menuKey] = indexMenu.split('-');
    this.select(menuKey)
  }
},
select(key) {
  this.active = key;
  this.$store.commit("setMenuTitle", key);
  // 【核心修复】原来写的 /pages/${key}，现在改为 /opr/${key}
  this.$router.push({
    path: `/opr/${key}`
  });
},
    // select(key) {
    //   this.active = key;
    //   this.$store.commit("setMenuTitle", key);
    //   this.$router.push({ path: `/pages/${key}`, query: { ut: Date.now() } });
    // },
    handleOpen(key, keyPath) {
      // console.log("open")
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log("close")
      // console.log(key, keyPath);
    },
    goToWorkbench() {
      window.location.replace("https://uat.lingshutong.cn/#/desktop")
    },
  }
};

</script>
<style lang="sass" scoped>
.sidebar
  width: 200px
  height: 100%
  position: fixed
  background: #272727
.el-menu
  border-right: 0

.back-workbench-btn
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  color: #fff;
  cursor: pointer;
  border-bottom: 1px solid #333; /* 加一条分隔线，和下面的菜单区分开 */
  transition: background 0.2s;

  .back-workbench-btn:hover
    background: #333;

  .back-workbench-btn .icon
    font-size: 18px;

  .back-workbench-btn .text
    font-size: 18px;


</style>



// WEBPACK FOOTER //
// src/opr/pages/layout/SideBar.vue